<label class="radio-item radio-primary"
       [class.checked]="checked"
       (click)="onClick.emit(value)">
  <input type="radio"
         [checked]="checked"
         [value]="value"
         [name]="name"/>
  <span>
    <ng-content></ng-content>
  </span>
</label>
